import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { INoticeMessage, createNoticeMessage, pageNoticeMessages } from '../../service/api/noticeMessage';
import { IStore, listStores } from '../../service/api/store';
import moment from 'moment';
import { FormInstance } from 'antd/lib/form/Form';
import { IAccount,listAccounts } from '../../service/api/account';
import { ITeachClass, listTeachClasss } from '../../service/api/teachClass';
import { IStudent, listStudents } from '../../service/api/student';
const { confirm } = Modal;
const { Option } = Select;

const NoticeMessageView = (props: any) => {
  const [teachClasss, setTeachClasss] = useState<ITeachClass[]>();
  const [stores, setStores] = useState<IStore[]>();
  const [students, setStudents] = useState<IStudent[]>();
  const [noticeMessages, setNoticeMessages] = useState<INoticeMessage[]>();
  const [accounts, setAccounts] = useState<IAccount[]>();
  const [noticeMessageDetail, setNoticeMessageDetail] = useState<INoticeMessage>();
  const [noticeMessageVisible, setNoticeMessageVisible] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [loading, setLoading] = useState(false);
  const formRef = React.createRef<FormInstance>();

  const columns = [
    {
      title: '通知名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '平台',
      dataIndex: 'platformName',
      key: 'platformName',
    },
    {
      title: '类型',
      dataIndex: 'typeName',
      key: 'typeName',
    },
    {
      title: '发送的学员',
      dataIndex: 'studentNames',
      key: 'studentNames',
      render: (text: any, record: any) => {
        return record.studentNames?record.studentNames:<>&mdash;</>
      }
    },
    {
      title: '发送的班级',
      dataIndex: 'teachClassNames',
      key: 'teachClassNames',
      render: (text: any, record: any) => {
        return record.teachClassNames?record.teachClassNames:<>&mdash;</>
      }
    },
    {
      title: '发送的通知',
      dataIndex: 'storeNames',
      key: 'storeNames',
      render: (text: any, record: any) => {
        return record.storeNames?record.storeNames:<>&mdash;</>
      }
    },
    {
      title: '发送状态',
      dataIndex: 'status',
      key: 'status',
      render: (text: any, record: any) => {
        if (record.status=='finish') {
          return <span style={{ color: 'green' }}>已完成</span>
        } else if (record.status=='running') {
          return <span style={{ color: 'grey' }}>发送中</span>
        }
      }
    },
    {
      title: '创建时间',
      dataIndex: 'creationTime',
      key: 'creationTime',
      render(val: Date) {
        return val ? moment(val).format('YYYY-MM-DD HH:mm') : <>&mdash;</>
      },
    },
    {
      title: '创建人',
      dataIndex: 'createdBy',
      key: 'createdBy',
    }
    // {
    //   title: '操作',
    //   key: 'action',
    //   render: (text: any, record: INoticeMessage) => (
    //     <Space size="middle">
    //       <a onClick={() => {
    //         // console.log("record:" + JSON.stringify(record));
    //         // if(typeof(record.openTime) === 'string') {
    //         //   record.openTime = moment(new Date(record.openTime)).add(8, 'hour')
    //         // }
    //         setNoticeMessageDetail(record);
    //         setNoticeMessageVisible(true);
    //       }}>编辑 </a>
    //       <a target="_blank" href={'#/app/noticeMessage/classroom?noticeMessageId='+record.id+'&&noticeMessageName='+record.name} >教室管理 </a>
    //       {/* <a onClick={e=>{onDelete(e,record)}}>删除 </a> */}
    //     </Space>
    //   ),
    // }
  ];

  useEffect(() => {
    loadData();
  }, [pageNum, pageSize]);

  useEffect(() => {
    if (noticeMessageDetail) {
      let copyFormData = JSON.parse(JSON.stringify(noticeMessageDetail))
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        formRef.current!.setFieldsValue(copyFormData);
      }, 100);
    }
  }, [noticeMessageDetail]);

  const loadData = () => {
    pageNoticeMessages(pageNum, pageSize).then((info: any) => {
      setNoticeMessages(info?.data.list);
      setPageTotal(info?.data.total);
      // console.log("info:" + JSON.stringify(info.data));
    });
    listStores().then((info: any) => {
      setStores(info?.data);
    });
    listTeachClasss().then((info: any) => {
      setTeachClasss(info?.data);
    });
    listStudents().then((info: any) => {
      setStudents(info?.data);
    });
    // listAccounts().then((info: any) => {
    //   setAccounts(info?.data);
    // });
  }

  const onFinish = (values: any) => {
    setLoading(true);
    createNoticeMessage(values).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if(info){
        message.success("创建成功");
        setNoticeMessageVisible(false);
        setNoticeMessageDetail(undefined);
        setLoading(false);
        loadData();
        }
      });
  };

  // const onDelete = (e: any, item: INoticeMessage) => {
  //   e.stopPropagation();
  //   confirm({
  //     title: '提示',
  //     icon: <ExclamationCircleOutlined />,
  //     content: '确定要删除该通知吗？删除后无法恢复',
  //     okText: '确定',
  //     okType: 'danger',
  //     cancelText: '取消',
  //     onOk() {
  //       deleteNoticeMessage(item.id).then((info: any) => {
  //         console.log("info:" + JSON.stringify(info));
  //         message.success("删除成功");
  //         loadData();
  //       });
  //     },
  //     onCancel() {
  //     },
  //   });
  // }

  const onClose = () => {
    setNoticeMessageDetail(undefined);
    setNoticeMessageVisible(false);
    if (formRef.current) {
      formRef.current!.resetFields();
    }
  }

  const onPageChange = (pageNum: number, pageSize?: number) => {
    console.log("pageNum:" + pageNum);
    console.log("pageSize:" + pageSize);
    setPageNum(pageNum);
    setPageSize(pageSize||10);
    // setPageSize(info.data.pageSize);
  }


  function onDateChange(value: any, dateString: any) {
    console.log('Selected Time: ', value);
    console.log('Formatted Selected Time: ', dateString);
  }

  function onDateOk(value: moment.MomentInput) {
    console.log('onOk: ', value);
    value = moment(value).format('YYYY-MM-DD HH:mm:ss') //这么解决的
  }

  // 下拉框值
  const accountOptions = accounts?.map((account) =>
    <Option key={account.id} value={account.id}>{account.username}</Option>);

     // 下拉框值
     const storeOptions = stores?.map((store) =>
     <Option key={store.id} value={store.id}>{store.name}</Option>);

       // 下拉框值
  const teachClassOptions = teachClasss?.map((teachClass) =>
  <Option key={teachClass.id} value={teachClass.id}>{teachClass.name}</Option>);

  const studentOptions = students?.map((student) =>
  <Option key={student.id} value={student.id}>{student.name}</Option>);

  //【知识点】 select 搜索
  return (
    <div className="gutter-example">
      <BreadcrumbCustom breads={['通知管理']} />
      <Row gutter={16}>
        <Col className="gutter-row" md={24}>
          <div className="gutter-box">
            <Card title="通知管理" bordered={false} extra={
              <Button type="primary" onClick={() => {
                setNoticeMessageVisible(true);
              }} icon={<PlusOutlined />}>
                新增
              </Button>
            }>
              <Table dataSource={noticeMessages} columns={columns} pagination={false} />
              <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "10px" }}>
                <Pagination
                  defaultCurrent={pageNum}
                  total={pageTotal}
                  pageSize={pageSize}
                  hideOnSinglePage={false}
                  className="pagination"
                  onChange={onPageChange}
                  showSizeChanger
                  showTotal={total => `共计 ${total} 条`}
                />
              </div>
            </Card>
          </div>
        </Col>
      </Row>
      <Drawer
        title={noticeMessageDetail ? "编辑通知" : "新增通知"}
        visible={noticeMessageVisible}
        width={720}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onFinish} ref={formRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="name"
                label="通知名"
                rules={[{ required: true, message: '请输入通知名' }]}
              >
                <Input placeholder="请输入通知名" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="platform"
                label="发送的平台"
                required={true}
                rules={[{ required: true, message: '请选择平台' }]}
              >
                 <Select >
                  <Option value="message">短信</Option>
                  {/* <Option value="wechat">微信服务号</Option> */}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="type"
                label="发送的类型"
                rules={[{ required: true, message: '请选择类型' }]}
              >
                <Select >
                  <Option value="bindWechatCode">绑定微信服务号</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
          <Col span={8}>
              <Form.Item
                name="studentIds"
                label="学员"
                rules={[{ required: false, message: '请选择学员' }]}
              >
                <Select placeholder="请选择学员" mode="multiple" 
                showSearch
                allowClear
                filterOption={(input, option) =>
                  option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                } >
                 {studentOptions}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="teachClassIds"
                label="班级"
                rules={[{ required: false, message: '请选择班级' }]}
              >
                <Select placeholder="请选择班级" mode="multiple" 
                showSearch
                allowClear
                filterOption={(input, option) =>
                  option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                } >
                 {teachClassOptions}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
            <Form.Item
                name="storeIds"
                label="门店"
                rules={[{ required: false, message: '请选择门店' }]}
              >
                <Select placeholder="请选择门店" mode="multiple" 
                showSearch
                allowClear
                filterOption={(input, option) =>
                  option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                } >
                  {storeOptions}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </div>
  );
};

export default NoticeMessageView;
